module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Partnerss/partners/partners.component.css
// module id = ./src/app/Partnerss/partners/partners.component.css
// module chunks = main